var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayBlack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(-291 -643)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 45,
    height: 45,
    rx: 4,
    transform: "translate(291 643)",
    fill: "#126cfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M9.266,4.11A2.351,2.351,0,0,0,7,6.419V22.3a2.344,2.344,0,0,0,3.444,2.029L24.779,16.39a2.345,2.345,0,0,0,0-4.057L10.444,4.391A2.235,2.235,0,0,0,9.266,4.11Z",
    transform: "translate(297.026 651.139)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayBlack);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NSIgaGVpZ2h0PSI0NSIgdmlld0JveD0iMCAwIDQ1IDQ1Ij4KICA8ZyBpZD0iR3JvdXBfMTkzIiBkYXRhLW5hbWU9Ikdyb3VwIDE5MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI5MSAtNjQzKSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzY1IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA2NSIgd2lkdGg9IjQ1IiBoZWlnaHQ9IjQ1IiByeD0iNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjkxIDY0MykiIGZpbGw9IiMxMjZjZmMiIG9wYWNpdHk9IjAiLz4KICAgIDxwYXRoIGlkPSJwbGF5IiBkPSJNOS4yNjYsNC4xMUEyLjM1MSwyLjM1MSwwLDAsMCw3LDYuNDE5VjIyLjNhMi4zNDQsMi4zNDQsMCwwLDAsMy40NDQsMi4wMjlMMjQuNzc5LDE2LjM5YTIuMzQ1LDIuMzQ1LDAsMCwwLDAtNC4wNTdMMTAuNDQ0LDQuMzkxQTIuMjM1LDIuMjM1LDAsMCwwLDkuMjY2LDQuMTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOTcuMDI2IDY1MS4xMzkpIi8+CiAgPC9nPgo8L3N2Zz4K";